import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import { supportAdmin } from '../../constants/appConstants';
import PageLoader from '../loaders/pageLoader';
import { rootLoader } from '../loaders/rootLoader';
import { supportSettingsLoader } from '../loaders/supportSettings';
import ProtectedRoute from '../protectedRoute';
import { queryClient } from '../queryClient';

const SupportSettingsPage = lazy(() => import('../../components/pages/supportSettings'));

const supportSettingsPath = '/manage/settings' as const;

export const supportAdminSettingsRoutes = {
	path: supportSettingsPath,
	element: <Outlet />,
	children: [
		{
			index: true,
			element: (
				<ProtectedRoute allowedRoles={[supportAdmin]}>
					<Suspense fallback={<PageLoader />}>
						<SupportSettingsPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, settingsData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					supportSettingsLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...settingsData,
				};
			},
		},
	],
};
